import type { MfaFactor } from '@/features/Auth/gcp/gcpAuth';

/** Never remove the previous factor until a newly enrolled factor of the same
 * type is visible. Ambiguous/concurrent changes require an explicit refresh. */
export async function retireReplacedMfaFactor(
  original: MfaFactor,
  before: Array<MfaFactor>,
  after: Array<MfaFactor>,
  remove: (uid: string) => Promise<void>,
) {
  const previousIds = new Set(before.map((factor) => factor.uid));
  const added = after.filter(
    (factor) =>
      factor.factorId === original.factorId && !previousIds.has(factor.uid),
  );
  if (
    !before.some(
      (factor) =>
        factor.uid === original.uid && factor.factorId === original.factorId,
    ) ||
    added.length !== 1 ||
    !['phone', 'totp'].includes(original.factorId)
  )
    throw new Error('Replacement could not be confirmed.');
  if (after.some((factor) => factor.uid === original.uid))
    await remove(original.uid);
}
